(() => {
  if (customElements.get('cart-extras')) return;

  class CartExtras extends HTMLElement {
    connectedCallback() {
      this.onChange = this.change.bind(this);
      this.onRefresh = () => {
        this.querySelectorAll('[data-unavailable]').forEach((input) => { input.disabled = true; });
        if (!this.busy) this.sync();
      };
      this.addEventListener('change', this.onChange);
      document.addEventListener('theme:cart:added', this.onRefresh);
      document.addEventListener('theme:cart:open', this.onRefresh);
      this.sync();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      document.removeEventListener('theme:cart:added', this.onRefresh);
      document.removeEventListener('theme:cart:open', this.onRefresh);
      this.revision = (this.revision || 0) + 1;
    }

    async request(path, body) {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}${path}`, {
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        ...(body ? { method: 'POST', body: JSON.stringify(body) } : {}),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'No pudimos actualizar el carrito. Inténtalo nuevamente.');
      return data;
    }

    applyCart(cart) {
      this.querySelectorAll('[data-extra-checkbox]').forEach((input) => {
        input.checked = cart.items.some((item) => String(item.variant_id) === input.value);
      });
    }

    async sync() {
      const revision = this.revision = (this.revision || 0) + 1;
      try {
        const cart = await this.request('cart.js');
        if (this.isConnected && revision === this.revision) this.applyCart(cart);
      } catch (_) {
        // Keep the server-rendered state; mutations always read a fresh cart.
      }
    }

    async change(event) {
      const input = event.target.closest('[data-extra-checkbox]');
      if (!input || this.busy) return;
      const selected = input.checked;
      const error = this.querySelector('[role="alert"]');
      this.busy = true;
      this.revision = (this.revision || 0) + 1;
      this.setAttribute('aria-busy', 'true');
      error.hidden = true;
      this.querySelectorAll('input').forEach((checkbox) => { checkbox.disabled = true; });
      const checkout = this.closest('form')?.querySelector('[name="checkout"]');
      const checkoutDisabled = checkout?.disabled;
      if (checkout) checkout.disabled = true;
      let changed = false;

      try {
        const cart = await this.request('cart.js');
        const matching = cart.items.filter((item) => String(item.variant_id) === input.value);
        if (selected && !matching.length) {
          await this.request('cart/add.js', { items: [{ id: Number(input.value), quantity: 1 }] });
          changed = true;
        } else if (!selected && matching.length) {
          const updates = Object.fromEntries(matching.map((item) => [item.key, 0]));
          await this.request('cart/update.js', { updates });
          changed = true;
        }

        const response = await fetch(`${window.theme.routes.cart_url}?section_id=api-cart-items`);
        if (!response.ok) throw new Error('El carrito cambió, pero no pudimos actualizar la vista. Vuelve a abrirlo o recarga la página.');
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = document.querySelector('[data-api-content]');
        const cartElement = this.closest('cart-element');
        if (!content || !cartElement?.build) throw new Error('Recarga la página para ver el carrito actualizado.');
        cartElement.build(content);
      } catch (failure) {
        if (!changed) input.checked = !selected;
        error.textContent = failure.message;
        error.hidden = false;
      } finally {
        this.busy = false;
        this.removeAttribute('aria-busy');
        this.querySelectorAll('input').forEach((checkbox) => { checkbox.disabled = checkbox.hasAttribute('data-unavailable'); });
        if (checkout) checkout.disabled = checkoutDisabled;
        await this.sync();
      }
    }
  }

  customElements.define('cart-extras', CartExtras);
})();
